import { reportRaptorMetrics } from '@/common/SLRaptor'
import * as React from 'react'
import { RAPTOR_SAMPLE_RATE, RESOURCE_ERROR_BOUNDARY } from './const'

interface ErrorBoundaryProps {
  raptorKey?: string
  tags?: any
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error: error.message }
  }

  componentDidCatch(error) {
    const { raptorKey = 'FFS_HOME_ERROR', tags = {} } = this.props
    reportRaptorMetrics({ [raptorKey]: 1 }, { error: error.message, ...tags }, RAPTOR_SAMPLE_RATE)
    Mach.requireModule('Raptor').reportBusinessException(RESOURCE_ERROR_BOUNDARY, error.stack, tags)
  }

  render() {
    if (this.state.error) {
      Mach.sendEvent('close')
      return null
    }
    return this.props.children
  }
}
export default ErrorBoundary
